<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative min-height-div {{
		sectionclass
	}}"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom primary-color-bg"
	>
		<div class="o-stack__cell portlet-subheader-wrapper" *ngIf="hasData">
			<h5 *ngIf="semCreativeCard">
				Creatives
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<img class="downloadIcon" src="{{ downloadIcon }}" />
					</a>
				</span>
			</h5>
		</div>
		<div class="o-stack__cell portlet-subheader-wrapper" *ngIf="!hasData">
			<h5>Creatives</h5>
		</div>
	</div>
	<div class="c-portlet__content u-pt-small" style="width: 100%; position: relative;" *ngIf="hasData">
		<div class="sem-creative-navigation">
			<div class="left-arrow" [ngClass]="{ arrows_disabled: totalCreatives == 1 }">
				<a class="u-opacity-50p">
					<span class="next" (click)="nextArrow()" class="cursor-pointer">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" />
					</span>
				</a>
			</div>
			<div class="creative-card-name">
				<h5>{{ semCreativeCard?.ad_headline }}</h5>
			</div>
			<div class="right-arrow" [ngClass]="{ arrows_disabled: totalCreatives == 1 }">
				<a class="u-opacity-50p">
					<span class="prev" (click)="prevArrow()" class="cursor-pointer">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" />
					</span>
				</a>
			</div>
		</div>
		<div class="creative-carousel">
			<div class="creativeImage textAlignCenter">
				<div class="sem-creative-card">
					<div class="sem-creative-heading">{{ semCreativeCard.ad_headline }}</div>
					<div class="sem-creative-card-link-container">
						<span class="sem-creative-card-text">AD</span>
						<cite class="sem-creative-card-link">{{ semCreativeCard.url }}</cite>
					</div>
					<span class="sem-creative-card-roboto">{{ semCreativeCard?.callExtension }}</span>
					<div
						*ngIf="isTypeString(semCreativeCard?.description); else elseBlock"
						class="sem-creative-card-description sem-creative-card-roboto"
					>
						{{ semCreativeCard?.description }}
					</div>
					<ng-template #elseBlock>
						<div class="sem-creative-card-description sem-creative-card-roboto">
							<p *ngFor="let desc of semCreativeCard?.description">
								{{ desc }}
							</p>
						</div>
					</ng-template>

					<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
						<div>
							<p>
								<span
									class="sem-creative-card-roboto"
									*ngFor="let callout of semCreativeCard?.calloutsExtn; let i = index"
									>{{ callout
									}}<span [ngClass]="{ last_callout_class: i == semCreativeCard?.calloutsExtn.length - 1 }">
										&middot;
									</span></span
								>
							</p>
						</div>
					</div>
					<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
						<div *ngFor="let snippet of semCreativeCard?.structuredSnippetExtn">
							<p class="sem-creative-card-roboto">{{ snippet?.type }}: {{ snippet?.value }}</p>
						</div>
					</div>
					<div class="sem-creative-card-siteLinks-container">
						<div *ngFor="let siteLink of semCreativeCard.siteLinks" class="sem-creative-card-sitelinks">
							<h4>
								<a href="{{ siteLink.link }}" target="_blank">{{ siteLink.heading }}</a>
							</h4>
							<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
						</div>
					</div>
					<div *ngIf="semCreativeCard?.location">
						<span class="sem-creative-card-location"
							><i
								class="fa fa-map-marker"
								aria-hidden="true"
								*ngIf="semCreativeCard.location"
								style="color: #575757;"
							></i>
							{{ semCreativeCard.location }}</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="analytics-portlet-content textAlignCenter" style="width: 100%;">
			<div class="display-carousel-table-container">
				<ul class="creative-stats">
					<li *ngFor="let metric of decodedMetrics">
						<span class="stats primary-color" *ngIf="!metric.showPercent">{{
							semCreativeCard[metric.value] ? (semCreativeCard[metric.value] | number) : '--'
						}}</span>
						<span class="stats primary-color" *ngIf="metric.showPercent"
							>{{ semCreativeCard[metric.value] | number: '0.2-2' }}%</span
						>
						<span class="stats-label">{{ metric.displayName }}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs no-data-min-ht"
		*ngIf="!hasData"
	>
		<img src="/assets/images/no-creative-performance-data-sem.png" class="no-creative-data" width="100%" />
	</div>
</div>
